import React from 'react'
import Button from '@material-ui/core/Button'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'

function Modal({ show, title, body, onValidate, onHide, size, withoutFooter }) {
  const hide = () => {
    if (onHide) {
      onHide()
    }
  }
  const validate = () => {
    if (onValidate) {
      onValidate()
    }
  }

  return (
    <Dialog centered open={show} onClose={onHide} size={size}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      {!withoutFooter && (
        <DialogActions className="py-1">
          <Button variant="outlined" onClick={hide} size="sm">
            Annuler
          </Button>
          <Button variant="contained" color="primary" onClick={validate} size="sm">
            Valider
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default Modal
